import React from 'react';
import { useRouter } from 'next/router';
import { Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import arFastrackContent from "@/locales/ar/fastrackContent";
import enFastrackContent from "@/locales/en/fastrackContent";

import cn from './DetectSignzyFailure.module.css'

export const SIGNZY_FAIL_STATUS_CODE = 'DOC_PROCESS_FAILED'

type DetectSignzyFailureProps = {
    onSignzyFail: () => void;
}
export function DetectSignzyFailure(props: DetectSignzyFailureProps) {
    const [showErrorPopup, setShowError] = React.useState(false);

    const router = useRouter();
    const { locale } = router;
    const tFastrackContent: any =
        locale == "en" ? enFastrackContent : arFastrackContent;

    React.useEffect(() => {
        const listenForFailureMessage = (event: MessageEvent) => {
            if (event.data === SIGNZY_FAIL_STATUS_CODE)
                setShowError(true);
        }
        window.addEventListener('message', listenForFailureMessage);
        return () => window.removeEventListener('message', listenForFailureMessage);
    }, [])

    const handleClosePopup = () => {
        props.onSignzyFail();
        setShowError(false)
    };

    return <Dialog
        open={showErrorPopup}
        onClose={handleClosePopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`${cn.statusPopup} statusPopup fastTrackError`}
    >
        <DialogTitle className={cn.modalTitleSection}>
            <div onClick={handleClosePopup} className={cn.close_btn}>
                <img src="/live/en/iceridgeresources/images/docusignPopupCloseButton.png"></img>
            </div>
            <img
                src="/live/en/iceridgeresources/images/popupFailureIcon.webp"
                className={`${cn.fastTrackErrorPopupImg} ${cn.fastTrackErrorPopupImgFailure}`}
            ></img>
        </DialogTitle>
        <DialogContent>
            <DialogContentText
                id="alert-dialog-description"
                className={cn.alert_dialog_description}
            >
                <span
                    className={cn.fastTrackStatusTextSection}
                >
                    {tFastrackContent.SIGNZY_FAILURE_ERROR}
                </span>

                <button
                    className={cn.fastTrackStatusGreySection}
                    onClick={handleClosePopup}
                >
                    {'Continue without ID verification'}
                </button>
            </DialogContentText>
        </DialogContent>
    </Dialog>
}